var a = "_heading6_18hla_1 _sharedTypography_qj5pz_1",
  e = {
    heading6: a
  };
export { e as default, a as heading6 };